import * as React from 'react'
import { SVGProps } from 'react'

const FTMUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill='white' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.334 12.8012L20.934 10.6907V14.9118L17.334 12.8012ZM20.935 21.8465L16.135 24.6606L11.335 21.8465V16.9219L16.135 19.7359L20.935 16.9219V21.8465ZM11.335 10.6907L14.935 12.8012L11.335 14.9118V10.6907ZM16.7354 13.8062L20.3354 15.9167L16.7354 18.0273V13.8062ZM15.5347 18.0273L11.9347 15.9168L15.5347 13.8062V18.0273ZM20.3347 9.68559L16.1347 12.0977L11.9347 9.68559L16.1347 7.17303L20.3347 9.68559ZM10.1348 9.28366V22.4495L16.1348 25.8666L22.1348 22.4495V9.28366L16.1348 5.86658L10.1348 9.28366Z'
      fill='#13B5EC'
    />
  </svg>
)

export default FTMUSD
